<template>
  <el-dialog v-model="visibled" title="教师课时统计" width="800" @close="onClose">
    <el-form>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="年份">
            <el-select v-model="filter.year" placeholder="请选择" @change="getSearch">
              <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="月份">
            <el-select v-model="filter.month" placeholder="请选择" @change="getSearch">
              <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <h3>上课总课时：{{ detail.allCount }}节课</h3>
    <!-- 月份总课时 -->
    <h3>{{filter.year}}年{{filter.month}}月总课时：{{ detail.monthCount }}节课</h3>
    <el-table
      :data="pages.list"
      style="width: 100%"
      max-height="600"
      border
    >
      <el-table-column
        prop="subjectName"
        label="教学科目"
      >
      </el-table-column>
      <el-table-column
        prop="count"
        label="课时"
      >
      </el-table-column>
    </el-table>
    <br>
    <!-- <pagination
      :page="pages.page"
      :pagesize="pages.pagesize"
      :total="pages.total"
      @on-page-change="handleChange"
    ></pagination> -->

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="modalshow = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
    import { reactive, nextTick, ref, watchEffect } from 'vue'
    import { usePageList } from '@/hooks/use-page-list'
    import Pagination from '@/components/Pagination'
    import { fetchGetTeacherInfo } from '@/service/main/system/system'
    const emits = defineEmits(['close'])
    const props = defineProps({
      show: {
        type: Boolean,
        default: false
      },
      teacherId: {
        type: String,
        default: ''
      }
    })

    const visibled = ref(false)
    const detail = ref({})

    watchEffect(() => {
      visibled.value = props.show
      if (props.show) {
        nextTick(() => {
          initYearMonth()
          getList()
        })
      }
    })

    const monthOptions = ref([])
    const yearOptions = ref([])
    const filter = reactive({
      year: '',
      month: '',
    })

    // 初始化年份和月份选项
    let initYearMonth = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;

      for (let i = 2024; i <= currentYear; i++) {
        yearOptions.value.push(i);
      }
      // 月份：1~12
      monthOptions.value = Array.from({ length: 12 }, (_, i) => {
        let label = i + 1;
        let value = i + 1;
        if(i < 9) {
          value = '0' + (i + 1);
        }
        return {
          label,
          value
        };
      });
      // 默认值
      console.log(monthOptions)
      filter.year = currentYear;
      filter.month = currentMonth;
    }

    const pages = reactive({
        page: 1,
        pagesize: 10,
        total: 0,
        loading: false,
        list: []
    })
    // const { fetchGetList } = usePageList('app/classFeedback/list')

    const getList = async () => {
        const { page, pagesize } = pages
        let { year, month } = filter
        pages.loading = true
        try {
          pages.list = []
          const currentMonth = monthOptions.value.find(item => item.label == filter.month)?.value || monthOptions.value[0].value
          console.log(currentMonth)
          const res = await fetchGetTeacherInfo({
            page,
            pagesize,
            year,
            month: currentMonth,
            teacherId: props.teacherId
          })
          detail.value = res.data || {}
          console.log(detail.value)
          pages.list = res.data?.subjectCountList || []
          
          // const res = await fetchGetList({
          //   page,
          //   pagesize,
          //   year,
          //   month,
          //   teacherId: props.teacherId
          // })
          // pages.total = Number(res.total)
          // pages.list = [
          //   {
          //     project: '小学-一年级-语文',
          //     totalNumber: 100
          //   }
          // ] || res.rows || []
        } catch (error) {
          pages.list = []
          // ElMessage.error('下载文件出现错误，请联系管理员！');
        } finally {
          pages.loading = true
        }
    }

    const getSearch = () => {
      pages.page = 1
      getList()
    }


    const handleChange = (e) => {
      pages.page = e.page
      pages.pagesize = e.pagesize
      getList()
    }

    const onClose = () => {
      emits('close', false)
    }

</script>

<style>

</style>